export const STAFF_DEPARTMENTS = [
  "Office",
  "Frontdesk",
  "Housekeeping",
  "Food & Beverage",
  "Security",
  "Maintenance",
  "Other",
];

export const normalizeStaffDepartment = (department) =>
  department === "Admin" ? "Office" : department || "Other";

const DEPARTMENT_KEYS = {
  Office: "office",
  Frontdesk: "frontdesk",
  Housekeeping: "housekeeping",
  "Food & Beverage": "foodBeverage",
  Security: "security",
  Maintenance: "maintenance",
  Other: "other",
};

export const staffDepartmentLabel = (department, t) => {
  const normalized = normalizeStaffDepartment(department);
  const key = DEPARTMENT_KEYS[normalized];
  return key ? t(`staffDepartments.${key}`, normalized) : normalized;
};
